'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';

const NAV_LINKS = [
  { label: 'Nosotros', href: '#nosotros' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Proceso', href: '#proceso' },
  { label: 'Casos', href: '#casos' },
  { label: 'Contacto', href: '#contacto' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'backdrop-blur-sm' : 'bg-transparent'
      }`}
      style={scrolled ? { background: 'rgba(247,243,236,0.97)', borderBottom: '1px solid rgba(196,180,154,0.3)' } : {}}
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-3" aria-label="Gestra Antiokupa inicio">
          <Image
            src="/assets/images/LOGOGESTRA-removebg-preview-1774972076274.png"
            alt="Gestra Antiokupa — Logo toro con escudo"
            width={44}
            height={44}
            className="object-contain"
          />
          <span
            className="font-semibold text-base tracking-widest uppercase"
            style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.18em', color: scrolled ? '#2A2520' : '#F7F3EC' }}
          >
            Gestra Antiokupa
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="text-xs font-medium tracking-widest uppercase transition-colors duration-200"
              style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.12em', color: scrolled ? 'rgba(42,37,32,0.55)' : 'rgba(247,243,236,0.65)' }}
              onMouseEnter={e => (e.currentTarget.style.color = scrolled ? '#2A2520' : '#F7F3EC')}
              onMouseLeave={e => (e.currentTarget.style.color = scrolled ? 'rgba(42,37,32,0.55)' : 'rgba(247,243,236,0.65)')}
            >
              {link?.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <a
          href="#contacto"
          className="hidden lg:inline-flex items-center gap-2 px-6 py-2.5 text-xs font-semibold tracking-widest uppercase transition-all duration-200"
          style={{
            fontFamily: 'Montserrat, sans-serif',
            letterSpacing: '0.15em',
            background: 'transparent',
            border: scrolled ? '1px solid rgba(42,37,32,0.3)' : '1px solid rgba(247,243,236,0.4)',
            color: scrolled ? '#2A2520' : '#F7F3EC',
          }}
          onMouseEnter={e => {
            (e.currentTarget as HTMLElement).style.background = scrolled ? 'rgba(42,37,32,0.08)' : 'rgba(247,243,236,0.12)';
          }}
          onMouseLeave={e => {
            (e.currentTarget as HTMLElement).style.background = 'transparent';
          }}
        >
          Solicitar Evaluación
        </a>

        {/* Mobile menu toggle */}
        <button
          className="lg:hidden p-2"
          style={{ color: scrolled ? '#2A2520' : '#F7F3EC' }}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            {menuOpen ? (
              <path d="M18 6L6 18M6 6l12 12" />
            ) : (
              <>
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="lg:hidden border-t px-6 py-6 flex flex-col gap-4" style={{ background: '#F7F3EC', borderColor: 'rgba(196,180,154,0.3)' }}>
          {NAV_LINKS?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              onClick={() => setMenuOpen(false)}
              className="text-xs font-medium tracking-widest uppercase py-2 transition-colors duration-200"
              style={{ fontFamily: 'Montserrat, sans-serif', color: 'rgba(42,37,32,0.6)', letterSpacing: '0.12em' }}
            >
              {link?.label}
            </a>
          ))}
          <a
            href="#contacto"
            onClick={() => setMenuOpen(false)}
            className="mt-2 inline-flex items-center justify-center px-6 py-3 text-xs font-semibold tracking-widest uppercase"
            style={{ fontFamily: 'Montserrat, sans-serif', background: '#2A2520', color: '#F7F3EC', letterSpacing: '0.15em' }}
          >
            Solicitar Evaluación
          </a>
        </div>
      )}
    </header>
  );
}